export default __webpack_public_path__ + "static/media/profile-boobilion.05cdb7fd.png";